import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tooltip" }
const _hoisted_2 = { class: "tooltip-content" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, {
      "open-on-hover": !_ctx.isTouch,
      "open-on-click": _ctx.isTouch,
      location: "top",
      offset: "5 0",
      "close-delay": "250",
      "content-class": "elevation-1"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_icon, _mergeProps(props, {
          class: "tooltip-icon",
          size: 20,
          color: _ctx.color
        }), {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" mdi-information-outline ")
          ])),
          _: 2
        }, 1040, ["color"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "tooltip-text",
            innerHTML: _ctx.content
          }, null, 8, _hoisted_3)
        ])
      ]),
      _: 1
    }, 8, ["open-on-hover", "open-on-click"])
  ]))
}